import { Module } from 'vuex'
import { RootState } from '../types'

interface NotificationState {
	successMessage: string | null
	showSuccessModal: boolean
	errorMessage: string | null
	showErrorModal: boolean
}

const notificationModule: Module<NotificationState, RootState> = {
	namespaced: true,

	state: {
		successMessage: null,
		showSuccessModal: false,
		errorMessage: null,
		showErrorModal: false
	},

	mutations: {
		SET_SUCCESS_MESSAGE(state: NotificationState, message: string | null) {
			state.successMessage = message
		},
		SET_SHOW_SUCCESS_MODAL(state: NotificationState, show: boolean) {
			state.showSuccessModal = show
		},
		SET_ERROR_MESSAGE(state: NotificationState, message: string | null) {
			state.errorMessage = message
		},
		SET_SHOW_ERROR_MODAL(state: NotificationState, show: boolean) {
			state.showErrorModal = show
		}
	},

	actions: {
		showSuccess({ commit }: { commit: any }, message: string) {
			commit('SET_SUCCESS_MESSAGE', message)
			commit('SET_SHOW_SUCCESS_MODAL', true)
		},
		hideSuccess({ commit }: { commit: any }) {
			commit('SET_SUCCESS_MESSAGE', null)
			commit('SET_SHOW_SUCCESS_MODAL', false)
		},
		showError({ commit }: { commit: any }, message: string) {
			commit('SET_ERROR_MESSAGE', message)
			commit('SET_SHOW_ERROR_MODAL', true)
		},
		hideError({ commit }: { commit: any }) {
			commit('SET_ERROR_MESSAGE', null)
			commit('SET_SHOW_ERROR_MODAL', false)
		}
	}
}

export default notificationModule
